import { createFileRoute, Link } from "@tanstack/react-router"
import { Trans, useTranslation } from "react-i18next";

import Button from "@/components/button";

export const Route = createFileRoute('/static/welcome')({
    component: WelcomePage
})

function WelcomePage() {
    const { t } = useTranslation("auth");
    return (
        <main className="min-h-screen w-full bg-cocoa grid grid-cols-1 md:grid-cols-2">
            <div className="left bg-linear-26 from-cocoa to-ember h-full flex items-center justify-center">
                <img
                    src="/bg-pattern.png"
                    alt="Pattern"
                    className="w-full object-cover max-h-[200px] md:max-h-none h-auto px-4"
                />

            </div>

            <div className="flex flex-col items-left justify-center px-4 lg:px-[70px] gap-[21px] bg-white">
                <img src="/newlogo.svg" alt="Logo" height={40} className="w-auto mb-[9px]" />
                <h1 className="heading-1">{t("landing.welcomeTitle")}</h1>
                <p className="body max-w-[375px] md:max-w-[413px]">
                    {t("landing.intro")}
                </p>
                <p className="body max-w-[375px] md:max-w-[413px]">
                    <Trans
                        i18nKey="landing.lookingForWork"
                        ns="auth"
                        components={{ strong: <strong /> }}
                    />
                    <br />
                    <Trans
                        i18nKey="landing.needStaff"
                        ns="auth"
                        components={{ strong: <strong /> }}
                    />
                </p>
                <Button variant="primary" className="max-w-[375px] md:w-[413px]" asChild>
                    <Link to="/auth/signup">{t("landing.getStarted")}</Link>
                </Button>
                <Button variant="secondary" className="max-w-[375px] md:w-[413px]" asChild data-testid="login-button">
                    <Link to="/auth/login">{t("landing.logIn")}</Link>
                </Button>
            </div>
        </main>
    );
}

